<template>
    <div>
        <template v-if="isNotEffective">
            <span
                :class="getLinkClass"
                @click="$emit('download-due', dueId)"
            >
                DUE en cours de création
            </span>
            <br>
        </template>

        <template v-else>
            <template v-if="!hasAmendmentDues">
                <span
                    :class="getLinkClass"
                    @click="$emit('download-due', dueId)"
                >
                    <span :id="effectiveWithoutAmandementId">DUE en vigueur</span>
                    <b-tooltip :target="effectiveWithoutAmandementId" variant="secondary">
                        Votre DUE signé le {{ date | formatDateToDisplay }}
                    </b-tooltip>
                </span>
                <br>
            </template>

            <template v-else>
                <span
                    v-for="(amendmentDue, index) in amendmentDues"
                    :key="amendmentDue.id"
                    :class="getLinkClass"
                    @click="$emit('download-amendment-due', {
                        dueId,
                        amendmentDueId: amendmentDue.id
                    })"
                >
                    <template v-if="index === 0">
                        <span :id="lastAmandementId" class="amendment-due">DUE en vigueur</span>
                        <b-tooltip :target="lastAmandementId" variant="secondary">
                            Votre DUE avec avenant créé le {{ amendmentDue.createdAt | formatDateToDisplay }}
                        </b-tooltip>
                    </template>
                    <template v-else>
                        <span :id="previousAmandementId(amendmentDue.id)">DUE</span>
                        <b-tooltip :target="previousAmandementId(amendmentDue.id)" variant="secondary">
                            Votre DUE avec avenant créé le {{ amendmentDue.createdAt | formatDateToDisplay }}
                        </b-tooltip>
                        <br>
                    </template>
                </span>

                <span
                    :class="getLinkClass"
                    @click="$emit('download-due', dueId)"
                >
                    <span :id="effectiveWithAmandementId">DUE</span>
                    <b-tooltip :target="effectiveWithAmandementId" variant="secondary">
                        Votre DUE signé le {{ date | formatDateToDisplay }}
                    </b-tooltip>

                </span>
            </template>
        </template>

    </div>

</template>

<script>
import { formatDateToDisplay } from "@/utils/utils";

export default {
    name: "DocumentSlot",
    props: {
        dueId: {
            type: Number,
            required: true
        },
        amendmentDues: {
            type: Array,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: true
        },
        status: {
            type: String,
            required: true
        },
        date: {
            type: String,
            default: ''
        }
    },
    computed: {
        amendmentDuesLength() {
            return this.amendmentDues ? this.amendmentDues.length : 0;
        },
        hasAmendmentDues() {
            return this.amendmentDuesLength > 0;
        },
        getLinkClass() {
            return this.isLoading ? 'link-due--disabled' : 'link-due';
        },
        isNotEffective() {
            return this.status !== 'effective';
        },
        effectiveWithoutAmandementId() {
            return `effective-without-amandement-${this.dueId}`;
        },
        effectiveWithAmandementId() {
            return `effective-with-amandement-${this.dueId}`;
        },
        lastAmandementId() {
            if (!this.hasAmendmentDues) {
                return;
            }

            return `last-amandement-${this.amendmentDues[0].id}`;
        }
    },
    methods: {
        previousAmandementId(id) {
            return `previous-amandement-${id}`;
        }
    },
    filters: {
        formatDateToDisplay
    },
}
</script>
